import { createAsyncTypes } from 'utils/ActionCreator'

export const CAMPAIGNS_REQUEST_ASYNC = createAsyncTypes(
  'CAMPAIGNS_REQUEST',
  'Dashboard/Awareness/ShowReport'
)
export const CACHE_KEY_REQUEST_ASYNC = createAsyncTypes(
  'CACHE_KEY_REQUEST',
  'Dashboard/Awareness/ShowReport'
)
export const REPORT_REQUEST_ASYNC = createAsyncTypes(
  'REPORT_REQUEST',
  'Dashboard/Awareness/ShowReport'
)
export const DATE_FILTER_CHANGE = 'Dashboard/Awareness/ShowReport/DATE_FILTER_CHANGE'
export const CAMPAIGN_FILTER_CHANGE = 'Dashboard/Awareness/ShowReport/CAMPAIGN_FILTER_CHANGE'
